<template>
<div class="chapter">
<div class="inner_page">
<div class="center" id="image1">
<p class="image"><a href="#/022toc#toolsandtechniques"></a><img alt="Tools and Techniques" src="images/image-01.jpg" width="100%"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 007toolsandtechniques.vue?56cb39d4